<form action="" #addrecipientForm = "ngForm" (ngSubmit)="addAndApprove(addrecipientForm)">
    <input type="text" name="nickname" ngModel required>
    <input type="text" name="address" ngModel required>
    <input type="text" name="street" ngModel required>
    <input type="text" name="postalCode" ngModel required>
    <button type="submit" [disabled]="!addrecipientForm.valid">SUBMIT</button>
</form>